import useUser from '../../../contexts/hooks/useUser'
import { trpc } from '../../../modules/trpc'

export const useOldContracts = (fetchOldContracts: boolean) => {
	const { user } = useUser()

	const utils = trpc.useContext()

	const { data: userQueryData, isLoading: userLoading } = trpc.synerall.userByPid.useQuery(
		{
			personalId: user?.personalId || '',
		},
		{
			enabled: Boolean(user?.personalId),
		}
	)

	// Try to get userData from cache if available, otherwise use query data
	const userData =
		utils.synerall.userByPid.getData({ personalId: user?.personalId || '' }) || userQueryData

	const { data: contractsQueryData, isLoading: contractsLoading } =
		trpc.synerall.getAllOldContractInformation.useQuery(
			{
				customerId: userData?.Id ?? 0,
			},
			{
				enabled: fetchOldContracts && !!userData?.Id,
				staleTime: Infinity, // Keep data fresh indefinitely
				cacheTime: 1000 * 60 * 60, // 1 hour cache
			}
		)

	// Try to get oldContractsData from cache if available, otherwise use query data
	const oldContractsData =
		utils.synerall.getAllOldContractInformation.getData({
			customerId: userData?.Id ?? 0,
		}) || contractsQueryData

	const isLoading = userLoading || contractsLoading

	const refetch = async () => {
		if (userData?.Id) {
			await utils.synerall.getAllOldContractInformation.refetch({
				customerId: userData.Id,
			})
		}
	}

	return {
		oldContractsData,
		isLoading,
		refetch,
	}
}
